import { styled } from "@mui/material";

const ContentActions = styled('div')`
  display: flex;
`;

export default ContentActions;
